<template>
  <div>
    <!-- head -->
    <div class="flex justify-between items-center p-2">
      <h5 style="line-height: 40px">
        <i class="dot" style="width: 8px; height: 8px"></i>
        {{ title }}
      </h5>
      <div v-if="!isPrint && !readonly">
        <slot name="buttons" />
        <vs-button color="secondary" @click="addRow"> 항목추가 </vs-button>
        <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow"> 선택삭제 </vs-button>
      </div>
    </div>
    <table>
      <colgroup>
        <col v-if="!isPrint && !readonly" width="4%" />
        <col v-if="!isPrint && !readonly" width="4%" />
        <col v-for="infoH in infoHeader.length + 3" :key="getHead(infoH)" :width="`${(isPrint || readonly ? 96 : 88) / (infoHeader.length + 3)}%`" />
      </colgroup>
      <thead>
        <tr>
          <th v-if="!isPrint && !readonly" class="select-none">
            <div class="flex justify-center items-center w-full">
              <vs-checkbox :value="0 < list.length && list.length === checkData.length" @click.native="onClickAllCheckBox" />
            </div>
          </th>
          <th v-if="!isPrint && !readonly" class="select-none">순서</th>
          <th v-for="infoH in infoHeader" :key="getHead(infoH)">{{ getHead(infoH) }}</th>
          <th>전일누계</th>
          <th>금일</th>
          <th>누계</th>
        </tr>
      </thead>

      <draggable
        v-model="list"
        tag="tbody"
        :disabled="isPrint || readonly"
        handle=".drag-handle"
        @end="onDragEnd"
      >
        <tr v-for="(item, item_i) in list" :key="item.id">
          <td v-if="!isPrint && !readonly" class="select-none">
            <div class="flex justify-center items-center w-full">
              <vs-checkbox v-if="!item.readonly" v-model="checkData" :vs-value="item.id" />
            </div>
          </td>
          <td v-if="!isPrint && !readonly" class="select-none">
            <div class="flex justify-center items-center w-full">
              <i class="feather icon-move drag-handle cursor-move text-gray-500" title="드래그하여 순서 변경"></i>
            </div>
          </td>
          <td v-for="infoH in infoHeader" :key="getHead(infoH)">
            <p v-if="isPrint" class="print-input my-1">{{ item[getHead(infoH)] }}</p>
            <CustomOptionSelector
              v-else-if="typeof infoH === 'object' && infoH.type === 'select'"
              autocomplete
              class="w-full flex-1 p-1"
              v-model.lazy="item[getHead(infoH)]"
              :options="infoH.option"
              :readonly="item.readonly || readonly"
              @input="changeOption(item_i, item, getHead(infoH))"
            />
            <ml-input v-else rows="1" class="w-full flex-1 p-1" placeholder="입력" :readonly="item.readonly || readonly" v-model.lazy="item[getHead(infoH)]" />
            <ml-input
              v-if="typeof infoH === 'object' && infoH.type === 'select' && item[getHead(infoH)] === '기타'"
              rows="1"
              class="w-full flex-1 p-1"
              placeholder="입력"
              :readonly="item.readonly || readonly"
              v-model.lazy="item[`${getHead(infoH)}_기타`]"
              @input="changeOption(item_i, item, getHead(infoH))"
            />
          </td>
          <td>
            <p v-if="isPrint" class="print-input my-1">{{ item.yesterday }}</p>
            <comma-input v-else readonly class="w-full flex-1 p-1" :placeholder="colPlaceholders[0]" v-model.lazy="item.yesterday" />
          </td>
          <td>
            <p v-if="isPrint" class="print-input my-1">{{ item.today }}</p>
            <comma-input v-else :readonly="readonly" class="w-full flex-1 p-1" :placeholder="colPlaceholders[1]" v-model.lazy="item.today" @input="rowTotal(item)" />
          </td>
          <td>
            <p v-if="isPrint" class="print-input my-1">{{ item.total }}</p>
            <comma-input v-else readonly class="w-full flex-1 p-1" :placeholder="colPlaceholders[2]" v-model.lazy="item.total" />
          </td>
        </tr>
      </draggable>

      <!-- 계  -->
      <tbody>
        <tr>
          <td :colspan="!isPrint && !readonly ? 2 + infoHeader.length : infoHeader.length" style="background: #f9f9f9" class="text-center">계</td>
          <td>
            <p v-if="isPrint" class="print-input my-1">
              {{ allYesterday | comma }}
            </p>
            <CommaInput v-else class="w-full flex-1 p-1" :placeholder="totalPlaceholders[0]" :value="allYesterday" readonly />
          </td>
          <td>
            <p v-if="isPrint" class="print-input my-1">
              {{ allToday | comma }}
            </p>
            <CommaInput v-else class="w-full flex-1 p-1" :placeholder="totalPlaceholders[1]" :value="allToday" readonly />
          </td>
          <td>
            <p v-if="isPrint" class="print-input my-1">{{ total | comma }}</p>
            <CommaInput v-else class="w-full flex-1 p-1" :placeholder="totalPlaceholders[2]" readonly :value="total" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import draggable from 'vuedraggable';

export default {
  components: {
    CustomOptionSelector,
    draggable
  },
  props: {
    title: String,
    isPrint: Boolean,
    infoHeader: Array,
    value: Array,
    colPlaceholders: {
      type: Array,
      default: () => ["", "", ""],
    },
    totalPlaceholders: {
      type: Array,
      default: () => ["", "", ""],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    // 최대 아이템 개수, 0일 경우 무제한
    maxLength: {
      type: Number,
      default: 0,
    },
    hideBudgetDay: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data() {
    return {
      list: this.value,
      checkData: [],
    };
  },
  computed: {
    allYesterday() {
      const _yd = this.list.reduce((prev, data) => {
        if (!!data.yesterday) return prev + Number(data.yesterday);
        else return prev;
      }, 0);
      return _yd;
    },
    allToday() {
      const _td = this.list.reduce((prev, data) => {
        if (!!data.today) return prev + Number(data.today);
        else return prev;
      }, 0);
      return _td;
    },
    total() {
      // const _tt = this.list.reduce((prev, data) => {
      //   if (!!data.total) return prev + Number(data.total);
      //   else return prev;
      // }, 0);
      // return _tt;
      return this.allYesterday + this.allToday;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
        this.$emit("budgetTotal", {
          yesterday: this.allYesterday,
          today: this.allToday,
          total: this.total,
        });
      },
    },
  },
  mounted() {
    window.addEventListener("setBudgetDayOldData", this.setBudgetDayOldData);
  },
  beforeDestroy() {
    window.removeEventListener("setBudgetDayOldData", this.setBudgetDayOldData);
  },
  methods: {
    getHead(infoH) {
      if (typeof infoH === "object") {
        return infoH.label;
      }
      return infoH;
    },
    // 항목추가
    addRow() {
      if (typeof this.list.length !== "undefined" && this.list.length >= this.maxLength) {
        alert(`${this.title} 데이터를 더 추가할 수 없습니다`);
        return;
      }
      this.list.push({ id: this.generateRandomString(6) });
    },
    // 선택삭제
    deleteRow() {
      this.list = this.list.filter((item) => {
        if (item.readonly) return true;
        return !this.checkData.includes(item.id);
      });

      this.checkData = [];
    },
    rowTotal(item) {
      if (item.yesterday) item.total = Number(item.yesterday) + Number(item.today);
      else item.total = Number(item.today);
    },
    onClickAllCheckBox() {
      if (this.list.length === this.checkData.length) this.checkData = [];
      else this.checkData = this.list.map((item) => item.id);
    },
    generateRandomString(num) {
      const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
      let result = "";
      const charactersLength = characters.length;
      for (let i = 0; i < num; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    changeOption(index, item, key) {
      if (!item[key]) return;
      let findItem;
      if (item[key] !== "기타") findItem = this.hideBudgetDay.find((_day) => _day[key] === item[key]);
      else if (item[key] === "기타" && !item[`${key}_기타`]) {
        findItem = this.hideBudgetDay.find((_day) => {
          if (_day[key] === "기타" && !_day[`${key}_기타`]) return true;
          else return false;
        });
      } else {
        findItem = this.hideBudgetDay.find((_day) => {
          if (!!_day[`${key}_기타`] && !!item[`${key}_기타`]) return _day[`${key}_기타`] === item[`${key}_기타`];
          else return false;
        });
      }

      this.$set(this.list[index], "yesterday", !!findItem ? findItem.yesterday : 0);
      this.$set(this.list[index], "total", !!findItem ? Number(item.today || 0) + Number(findItem.yesterday || 0) : item.today || 0);
    },
    setBudgetDayOldData() {
      this.$nextTick(() => {
        this.list.map((item, item_i) => {
          this.changeOption(item_i, item, this.infoHeader[0].label);
        });
      });
    },

    // 드래그 완료 시 호출되는 메서드
    onDragEnd(evt) {
      // 드래그 완료 후 추가 로직이 필요한 경우 여기에 구현
      this.$emit('orderChanged', {
        oldIndex: evt.oldIndex,
        newIndex: evt.newIndex,
        list: this.list
      });
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;

  text-align: left;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;

  border-collapse: collapse;
  margin-bottom: 28px;

  thead {
    th {
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;

      background: #f9f9f9;
      border: solid #cdcdcd 1px;
      padding: 16px 6px;
    }
  }
  tbody {
    tr {
      td {
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        border: solid #cdcdcd 1px;
      }
    }
  }
}

.drag-handle {
  font-size: 16px;

  &:hover {
    color: #007bff;
  }
}

.sortable-ghost {
  opacity: 0.5;
  background-color: #f0f0f0;
}

.sortable-chosen {
  background-color: #e3f2fd;
}
</style>
